/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_ConstruirRuta as ConstruirRuta,
  rec_Do as Do,
  rec_JSXRuntime as JSXRuntime,
  rec_Login as Login,
  rec_Mt as Mt,
  rec_PaginaNoEncontrada as PaginaNoEncontrada,
  rec_Pt as Pt,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_bo as bo,
  rec_jt as jt,
  rec_rt as rt,
} from "../../runtime/index.jsx";
export function RutasAplicacion() {
  let e = (0, ReactCompiler.c)(7),
    { pathname: t } = rt(),
    n;
  e[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((n = <Mt path={`/login`} element={<Login />} />), (e[0] = n))
    : (n = e[0]);
  let r;
  e[1] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((r = (
        <Mt
          path={`/areas`}
          element={(0, JSXRuntime.jsx)(jt, {
            to: `/organizacion`,
            replace: !0,
          })}
        />
      )),
      (e[1] = r))
    : (r = e[1]);
  let i, a;
  e[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((i = (
        <Mt
          path={`/objetivos/*`}
          element={(0, JSXRuntime.jsx)(jt, {
            to: `/organizacion`,
            replace: !0,
          })}
        />
      )),
      (a = bo.map(ConstruirRuta)),
      (e[2] = i),
      (e[3] = a))
    : ((i = e[2]), (a = e[3]));
  let o;
  e[4] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((o = (
        <Pt
          children={[
            n,
            r,
            i,
            a,
            <Mt path={`*`} element={<PaginaNoEncontrada />} />,
          ]}
        />
      )),
      (e[4] = o))
    : (o = e[4]);
  let s;
  return (
    e[5] === t
      ? (s = e[6])
      : ((s = <Do reiniciarCon={t} children={o} />), (e[5] = t), (e[6] = s)),
    s
  );
}
